/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProcessingOptions } from './processingOptions';


export interface DeliverySystemMessageLog { 
    id?: string;
    dateCreated: Date;
    duplicatedNumbersCount: number;
    duplicatedNumbers?: string;
    allNumbersCount: number;
    blockedNumbers?: string;
    blockedNumberCount: number;
    finalCountMessageWasSentTo: number;
    pages: number;
    processingOptions?: ProcessingOptions;
    referenceNumber?: string;
    creatorId?: string;
    senderId?: string;
    phoneNumbers?: string;
    textMessage?: string;
    smSRouteName?: string;
    transactionNote?: string;
    transactionStatusMessage?: string;
    transactionStatus: number;
    totalCost: number;
    anqLookUpClientId: number;
}
